<template lang="pug">
	.creative--publish-history.audio-tracker
		DxDropDownButton(
			:split-button="false",
			:dropDownOptions="{ width: '360px' }",
			:use-select-mode="false",
			:text="$tCaption('Publish history')",
			ref="publishDropdown",
			:hoverStateEnabled="false",
			:focusStateEnabled="false",
			:selectedItemKey="null",
			:items="publicationHistoryItems")
			template(v-slot:publishTemplate="{ data }")
				.click(@click.stop, :title="$tCaption('Publish history')")
					ListView.full-width(ref="publishHistory", :topPagerVisible="false", :showColumnHeaders="false", initialView="table", :columns="publishHistoryColumns",
						:width="480", :height="300", :searchVisible="false", :hideViewsSelection="true", :getTotal="(r) => r.TotalNumberOfRecords",
						:getItems="(r) => r.Results", :getData="getPublishHistory")
						span(slot="left-actions") {{$tCaption('Publish history')}}
						template(v-slot:displayValue="{ data }")
							.flex-col.space.creative-detail
								.flex-row.space.align-center.font-small(:class="data.HasWarnings ? 'warning-colored' : ['grey', 'success-colored', 'error-colored', 'grey'][data.Status]")
									i.fas(:class="data.HasWarnings ? 'fa-triangle-exclamation' : ['fa-hourglass-start', 'fa-check', 'fa-times', 'fa-times'][data.Status]")
									span {{$moment(data.GenerationStarted).format('llll')}}
									span(v-if="data.NeedsVideoPublish") ({{data.CountOfPublishedVariants}}/{{data.CountOfPublishedVariantsWithAudio}}/{{data.CountOfVariants}})
									span(v-else) ({{data.CountOfPublishedVariants}}/{{data.CountOfVariants}})
								.flex-col.space.wrap.align-end
									.creative-detail--in-queue.upper.font-mini(v-if="data.InAzureQueue")
										span {{$tCaption('You creative is in the publication queue. It may take a while.')}}
									.flex-row.space.align-center.wrap
										Loader(v-if="data.__isLoading", text="")
										AudioTrackerButton.padded(icon="fas fa-circle-info", :text="$tCaption('Logs')", @click="showPublicationSessionLogs(data)", :disabled="data.__isLoading")
										AudioTrackerButton.padded(v-if="(data.Status >= 2 || data.HasWarnings) && publicationStatistic && publicationStatistic.LastSession && publicationStatistic.LastSession.SessionId === data.SessionId", 
											:title="$tCaption('Retry')", icon="fas fa-redo-alt", 
											:text="$tCaption('Retry')", @click="() => $refs.creativePublish.publishFinalAudioServerside(data.SessionId)")
										AudioTrackerButton.padded(v-if="data.Status === 0", :title="$tCaption('Cancel')", icon="fas fa-times", :text="$tCaption('Cancel')", @click="() => cancelPublishFinalAudioServerside(data.SessionId)")
										AudioTrackerButton.padded(v-if="data.CreativeVariants.filter(f => hasPublicationFiles(f)).length > 0", :title="$tCaption('Download links in excel')", icon="fas fa-file-excel", 
											:text="$tCaption('Links')", @click="downloadVariantsAsLinks(data)")
									template(v-if="data.CreativeVariants.length <= 10")
										.variant(v-for="(variant, vIdx) in data.CreativeVariants.filter(f => hasPublicationFiles(f))")
											.warning-colored.flex-row.space.align-center(v-if="variant.HasError")
												i.fas.fa-triangle-exclamation
												.font-small {{ variant.Name || `${$tCaption('Variant')} ${vIdx + 1}` }}
											.flex-row.variant.space.align-center.wrap(v-else, :title="variant.Name")
												Loader(v-if="variant.__isDownloading", text="")
												.font-small {{ variant.Name || `${$tCaption('Variant')} ${vIdx + 1}`}}
												.flex-row.space.variant-button.adt-button.hoverable.clickable.align-center.center.padded.accent-color(
													v-if="variant.FinalAudio && variant.FinalAudio.FileName"
													:title="$tCaption('Download audio')", @click.stop="v => downloadPublishVariantAudio(variant, vIdx, 'audio')")
													i.fas.fa-download
												.flex-row.space.variant-button.adt-button.hoverable.clickable.align-center.center.padded.accent-color(
													v-if="variant.VideoLqUrl"
													:title="$tCaption('Download LQ video')", @click.stop="v => downloadPublishVariantAudio(variant, vIdx, 'VideoLqUrl')")
													span {{$tCaption('LQ')}}
													i.fas.fa-video
												.flex-row.space.variant-button.adt-button.hoverable.clickable.align-center.center.padded.accent-color(
													v-if="variant.VideoMqUrl"
													:title="$tCaption('Download MQ video')", @click.stop="v => downloadPublishVariantAudio(variant, vIdx, 'VideoMqUrl')")
													span {{$tCaption('MQ')}}
													i.fas.fa-video
												.flex-row.space.variant-button.adt-button.hoverable.clickable.align-center.center.padded.accent-color(
													v-if="variant.VideoHqUrl"
													:title="$tCaption('Download HQ video')", @click.stop="v => downloadPublishVariantAudio(variant, vIdx, 'VideoHqUrl')")
													span {{$tCaption('HQ')}}
													i.fas.fa-video
</template>

<script>
	import AudioTrackerButton from 'view/audioTracker/AudioTrackerButton.vue';
	import DxDropDownButton from 'devextreme-vue/drop-down-button';
	import ListView from 'app-core/ListView.vue';

	export default {
		translationCategory: 'creative.Detail',
		name: 'creative--publish-history',
		components: {
			DxDropDownButton, AudioTrackerButton, ListView
		},
		props: ['creative', 'hasPublishHistory', 'publicationStatistic', 'showPublicationSessionLogs', 'downloadVariantsAsLinks', 'cancelPublishFinalAudioServerside'],
		data() {
			return {
				publishHistoryColumns: [{ dataField: 'DisplayValue', cellTemplate: 'displayValue' }],
				publicationHistoryItems: [{ template: 'publishTemplate' }],
			};
		},
		computed: {
		
		},
		watch: {
		
		},
		methods: {
			hasPublicationFiles(v) {
				return v?.FinalAudio?.FileName || v?.VideoHqUrl || v?.VideoLqUrl || v?.VideoMqUrl;
			},
			downloadPublishVariantAudio(variant, idx, type) {
				if (__DEBUG__)
					console.debug('Download publish variant audio', { variant });

				let fileName = `${this.$tCaption('Variant')} #${idx + 1}`;

				switch(type) {
					case 'VideoLqUrl':
					case 'VideoMqUrl':
					case 'VideoHqUrl': {
						variant.__isDownloading = true;
						let link = document.createElement('a');
						link.href = variant[type];
						link.download = variant.Name ? `${variant.Name}.mp4` : `${this.$moment(variant.GenerationStarted).format('lll')} ${fileName}`;
						link.click();
						setTimeout(() => {
							if (this._isDestroyed) return;
							variant.__isDownloading = false;
						}, 500);
						break;
					}
					default: {
						variant.__isDownloading = true;
						this.$azure.getBlob(variant.FinalAudio.FileName, true, null, false, variant.FinalAudio.AzureContainer).then(r => {
							let objUrl = URL.createObjectURL(new Blob([r], { type: 'audio/wav' }));
							let link = document.createElement('a');
							link.href = objUrl;
							link.download = variant.Name ? `${variant.Name}.wav` : `${this.$moment(variant.GenerationStarted).format('lll')} ${fileName}`;
							link.click();
						}).finally(() => {
							setTimeout(() => {
								if (this._isDestroyed) return;
								variant.__isDownloading = false;
							}, 500);
						});
					}
				}
			},
			getPublishHistory(pageIndex, limit, opts) {
				return this.$Data
					.getCreativePublishHistory(pageIndex, limit, opts, this.creative?.Oid)
					.then(r => {
						r.Results?.map(c => c?.CreativeVariants?.map(v => v.__isDownloading = false));
						return r;
					});
			},
			reload() {
				if (this.$refs.publishHistory)
					this.$refs.publishHistory.reload();
			}
		}
	};
</script>
<style lang='scss'>
	.creative--publish-history {
	}
</style>
